import NextLink from 'next/link';

import { Modal } from '@frontendmentorio/design-system-v2';

export default function HTMLModal({ modal }) {
  return (
    <Modal modal={modal}>
      <Modal.Heading>How does the HTML validation report work?</Modal.Heading>

      <p>
        When a solution is submitted, we use{' '}
        <NextLink
          className="underline hover:no-underline"
          href="https://html-validate.org/"
        >
          html-validate
        </NextLink>{' '}
        to run an automated check on the HTML code.
      </p>

      <p>
        The report picks out common HTML issues such as not using headings
        within section elements and incorrect nesting of elements, among others.
      </p>

      <p>
        Note that the report can pick up “invalid” attributes, which some
        frameworks automatically add to the HTML. These attributes are crucial
        for how the frameworks function, although they’re technically not valid
        HTML. As such, some projects can show up with many HTML validation
        errors, which are benign and are a necessary part of the framework.
      </p>
    </Modal>
  );
}
